module.exports = __webpack_public_path__ + "img/down-sc2.e450da81.png";